export enum UploadStateType {
  INACTIVE,
  PREPARING,
  UPLOADING,
  ERROR,
}

export type IUploadState =
  | {
      type: UploadStateType.INACTIVE;
    }
  | {
      type: UploadStateType.PREPARING;
    }
  | {
      type: UploadStateType.UPLOADING;
      progress: number;
    }
  | {
      type: UploadStateType.ERROR;
      message: string;
    };
